export default {
  //loading: 'Loading…',
  error_bad_request: "Invalid request.",
  error_not_found: "Item not found.",
  error_fetch: "The request could not reach its destination: please check your connection or try again later.",
  error_server: "Unexpected server error. Please try again later.",

  // Home
  rafting: "Raft & mini-raft",
  canoraft: "Inflatable kayak",
  hydrospeed: "Riverboarding",
  pricing: "Pricing",
  more: "Infos",
  contact: "Contact",
  title: "Rafting in Saint-Lary (65)",
  description:
    "Downhill rafting is a water and environment discovery activity! Go down the river in an fun an easy way. It's a friendly outdoor aquatic experience surrounded by nature!",
  subtitle:
    "Beware! If you book, you are responsible for any side effects that a happiness overdose could cause in your life!",
  cta: "Book now",
  rafting_description:
    "Come and try an accessible and fun aquatic outdoor mountain activity. 1h30 to 1h45 of navigation and adventures aboard this big inflatable boat through an unforgettable scenery! With your family or friends, come for a rafting tour on the artery of the valley, the beautiful Neste d'Aure.",
  canoraft_description:
    "In pairs or solo, these small inflatable boats similar to rafts, also called canoraft or hot-dog, will allow a more independent and dynamic approach to the same route, with a small surprise halfway. Not recommended for fragile couples 😜",
  hydrospeed_description:
    "Also known as whitewater swimming, fins and this highly maneuverable device, originally created for whitewater rescue, offer a different approach to the river. More physical than inflatable boats, riverboarding allows you to better understand water movements and currents, while being totally immersed! To get the most out of riverboarding, we recommend that you have already used fins, and that you are at least 14 years old!",
  duration: "Duration: {duration}",
  departures: "Meet at 9:30am or 2:30pm",
  price: "Price: {price, number, money}",
  what_to_bring: "Gear you need to bring: your swimsuit and closed shoes. The rest is provided!",
  what_to_bring_light: "Gear you need to bring: your swimsuit. The rest is provided!",
  more_gear:
    "Apart from shoes and swimsuit, all equipment needed for the activities is included, as is the minibus shuttle back to the base.",
  more_infos: "All the gear is cleaned after each downhill.",
  instructor:
    "To combine security and fun, your instructors: Jean & Charlie, holders of a canoe & kayak BPJEPS certificate. They navigate the Neste river for more than 10 years. They are also rescuers at the Piau-Engaly ski resort",
  legal: "Legal notices and terms of sale",
  guides: "Jean & Charlie",
  // Calendar
  calendar_title: "Choose your date…",
  weekday1: "Monday",
  weekday2: "Tuesday",
  weekday3: "Wednesday",
  weekday4: "Thursday",
  weekday5: "Friday",
  weekday6: "Saturday",
  weekday7: "Sunday",
  morning: "Morning",
  afternoon: "Afternoon",
  spots: "{num, plural, one {One spot} other {# spots}}",
  full: "full",
  closed: "closed",
  after_season: "Sorry, the season has ended. See you next year!",

  // Book
  book_title: "Confirm your booking…",
  tomorrow_alert: "Book before 9pm to navigate tomorrow!",
  total: "Total {amount, number, money}",
  deposit: "Pay now: {amount, number, money} ({percent}% deposit)",
  remaining: "Left to be paid on the venue: {amount, number, money}",
  discount: "Click here if you have a promotional code",
  discount_placeholder: "Promo code…",
  discount_checking: "Checking…",
  discount_percent: "Including your {discount}% discount!",
  checkout_title: "Book for {people, plural, one {one person} other {# persons}}",
  checkout_description: "On {date, date, event} {type, select, morning {in the morning} afternoon {in the afternoon}}",
  checkout_label: "Pay",
  checkout_button: "Pay",
  paying: "Booking…",
  error_too_late: "Sorry, it's too late to book for tomorrow.",
  error_missing_spots: "Sorry, not enough spots available anymore for that day.",
  error_full: "Sorry, that day is full.",
  error_closed: "Sorry, we are closed on that day.",
  error_code_not_found: "This code does not exist or is not valid anymore.",
  unavailable_combination: "Sorry, this combination is not available. Try choosing another slot or activity.",

  // Thanks
  thanks_title: "Done!",
  thanks:
    "Thank you for your booking. If the payment is successful, you will receive a confirmation email with all the information.",

  // Forms
  form_name: "Full name",
  form_email: "Email address",
  form_message: "Your message",
  form_phone: "Phone number",
  form_people: "Persons",
  option_type: "{type, select, morning {Morning} afternoon {Afternoon}}",
  activities: "Activity:",
  option_activity:
    "{activity, select, rafting {Raft / mini-raft} canoraft {Canoraft (inflatable kayak)} hydrospeed {Hydrospeed (riverboarding / whitewater swimming)}}",
  option_activity_max: "{max, plural, one {1 spot} other {# spots}}",
  form_confirm: "I certify that everyone knows how to swim",
  form_referral: "How did you find us?",
  incomplete_form: "Please fill in all the fields to access checkout.",
  send: "Send",
  sent: "Your message has been sent. An answer will be provided as soon as possible.",
  unavailable: "Unavailable",
}
